export default "__VITE_ASSET__CO7YXJh3__"